import React from 'react';

import {defaultTheme} from '@ibibo/build-theme';

import * as S from './RefundSelect.styles';
import * as SS from '../CancellationBody.styles';

import RupeeIcon from '../../../../../../../../hotels-dweb/src/stories/Icons/RupeeIcon';

const RefundSelect = ({header, updateActiveTab, selectedRefundMode, updateRefundMode, refundBreakUp, confirmCancellation, previousTab='refund'}) => {
  const {total, pg, total_wallet, promo_wallet, wallet} = refundBreakUp;
  const showOriginalMode = (!!pg);
    return(
      <SS.CancelBreakUpMainWrap>
        <SS.CancelBreakUpHeaderWrap>
          <SS.BreakupHeaderMainText>Select a Refund Mode</SS.BreakupHeaderMainText>
          <SS.BreakupHeaderSubText>{header}</SS.BreakupHeaderSubText>
        </SS.CancelBreakUpHeaderWrap>

        <S.RefundSelectMainWrap>

          <S.RefundSelectInnerWrap onClick={() => {
            if (selectedRefundMode !== 'wallet') {
              updateRefundMode('wallet');
            }
          }}>
            <S.RefundModeSelectWrap>
              <S.RefundOptionSelectWrap>
              {selectedRefundMode === 'wallet' ? <S.RefundOptionSelected></S.RefundOptionSelected> : <S.RefundOptionSelect></S.RefundOptionSelect>}
                <S.RefundModeHeadText>MyPartner Wallet</S.RefundModeHeadText>
                <S.RefundStateText>INSTANT REFUND</S.RefundStateText>
              </S.RefundOptionSelectWrap>
              <S.RefundAmountText><RupeeIcon width="1.6rem" height="1.6rem" />{total.toLocaleString('en-IN')}</S.RefundAmountText>
            </S.RefundModeSelectWrap>
            {(total > 0 && <S.RefundDetailsInfoWrap>
              <S.RefundMainInfoText>
                <RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{total.toLocaleString('en-IN')} in MyPartner Wallet
              </S.RefundMainInfoText>
              <S.RefundSubInfoText>(<RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{(wallet + pg)} MyCash + <RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{promo_wallet} Promo Cash)</S.RefundSubInfoText>
              <S.RefundSubInfoText>After processing this amount will instantly reflect in your wallet. There is no expiry of this money except Promo Wallet Balance which will expire as per policy.</S.RefundSubInfoText>
            </S.RefundDetailsInfoWrap>) || null}
          </S.RefundSelectInnerWrap>

          {(showOriginalMode && <S.RefundSelectInnerWrap onClick={() => {
            if (selectedRefundMode !== 'original') {
              updateRefundMode('original');
            }
          }}>
            <S.RefundModeSelectWrap>
              <S.RefundOptionSelectWrap>
                {selectedRefundMode === 'original' ? <S.RefundOptionSelected></S.RefundOptionSelected> : <S.RefundOptionSelect></S.RefundOptionSelect>}
                <S.RefundModeHeadText>Original Pay Mode</S.RefundModeHeadText>
              </S.RefundOptionSelectWrap>
              <S.RefundAmountText><RupeeIcon width="1.6rem" height="1.6rem" />{total.toLocaleString('en-IN')}</S.RefundAmountText>
            </S.RefundModeSelectWrap>
            {(pg > 0 && <S.RefundDetailsInfoWrap>
              <S.RefundMainInfoText><RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{pg.toLocaleString('en-IN')} in the bank account</S.RefundMainInfoText>
              <S.RefundSubInfoText>After processing refund will take 4-5 days to reflect in your bank account</S.RefundSubInfoText>
            </S.RefundDetailsInfoWrap>) || null}
            {(total_wallet > 0 && <S.RefundDetailsInfoWrap>
              <S.RefundMainInfoText>
                <RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{total_wallet.toLocaleString('en-IN')} in MyPartner Wallet
              </S.RefundMainInfoText>
              <S.RefundSubInfoText>(<RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{(wallet)} MyCash + <RupeeIcon width="1.1rem" height="1.1rem" fill={defaultTheme.colors.grey.base} />{promo_wallet} Promo Cash)</S.RefundSubInfoText>
              <S.RefundSubInfoText>After processing this amount will instantly reflect in your wallet. There is no expiry of this money except Promo Wallet Balance which will expire as per policy.</S.RefundSubInfoText>
            </S.RefundDetailsInfoWrap>) || null}
          </S.RefundSelectInnerWrap>) || null}

        </S.RefundSelectMainWrap>

        <SS.CancelBtnWrap>
          <SS.BackOptionWrap onClick={() => updateActiveTab(previousTab)}>
            <SS.BackOptionText>Back</SS.BackOptionText>
          </SS.BackOptionWrap>
          <SS.CancelButtonWrap onClick={confirmCancellation}>
            <SS.CancelBtn>CONFIRM {previousTab === 'refund' ? 'CANCELLATION' : 'MODIFY'}</SS.CancelBtn>
            {(previousTab === 'refund' && <SS.CancelInfoText>Cancellation will be confirmed now</SS.CancelInfoText>) || null}
          </SS.CancelButtonWrap>
        </SS.CancelBtnWrap>

      </SS.CancelBreakUpMainWrap>
    );
}

export default RefundSelect;